import { createSlice, current } from '@reduxjs/toolkit';
import { graphqlApi } from '../api';
import { REVIEW_TYPES } from '../../../util/constants';

const BLANK_EXPRESSION = { expressionCriteria: null, operator: null, value: { type: "number", value: "" } };
const INITIAL_SELECTED_RULE = { reviewType: '', programId: '', label: '', expressionSets: [] }

const initialState = {
  selectedRule: INITIAL_SELECTED_RULE,
  attributes: [],
  defaults: [],
  rules: {},
  rulesCopy: {},
}

const criteriaSlice = createSlice({
  name: 'criteria',
  initialState,
  reducers: {
    setSelectedRule(state, action) {
      const currentState = current(state);
      if (action.payload?.newProgramId) {
        state.selectedRule = currentState.defaults.find(rule => rule.programId === action.payload.newProgramId) || INITIAL_SELECTED_RULE
      } else {
        state.selectedRule = action.payload
      }
    },
    addNewBlankRuleExpression(state, action) {
      const { programId, reviewType, exSetIdx } = action.payload
      const newExpression = {
        ...BLANK_EXPRESSION,
        expressionSetIndex: exSetIdx,
        reviewType: reviewType
      }
      state.rules[programId][reviewType].expressionSets[exSetIdx].push(newExpression)
    },
    updateRuleExpression(state, action) {
      const { expressionCriteria, operator, value, exSetIdx, exIdx } = action.payload
      const reviewType = current(state.selectedRule).reviewType
      const programId = current(state.selectedRule).programId
      state.rules[programId][reviewType].expressionSets[exSetIdx][exIdx].expressionCriteria = expressionCriteria
      state.rules[programId][reviewType].expressionSets[exSetIdx][exIdx].operator = operator
      state.rules[programId][reviewType].expressionSets[exSetIdx][exIdx].value.value = value
    },
    revertRulesChanges(state, action) {
      state.rules = current(state.rulesCopy)
    },
    deleteExpression(state, action) {
      const { programId, reviewType, exSetIdx, exIdx } = action.payload
      const arrayWithExpressionRemoved = current(state.rules[programId][reviewType].expressionSets[exSetIdx]).filter((ex, idx) => idx !== exIdx)
      state.rules[programId][reviewType].expressionSets[exSetIdx] = arrayWithExpressionRemoved
    },
    addNewExpressionSet(state, action) {
      const { programId, reviewType } = action.payload
      const currentExSetCount = current(state.rules[programId][reviewType].expressionSets).length
      state.rules[programId][reviewType].expressionSets.push([{
        ...BLANK_EXPRESSION,
        expressionSetIndex: currentExSetCount,
        reviewType: reviewType,
      }])
    },
    deleteExpressionSet(state, action) {
      const { programId, reviewType, exSetIdx } = action.payload
      state.rules[programId][reviewType].expressionSets = current(state.rules[programId][reviewType].expressionSets).filter((exSet, idx) => idx !== exSetIdx)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      graphqlApi.endpoints.getCriteria.matchFulfilled,
      (state, { payload }) => {
        const rules = { honors: {}, scholars: {} }

        payload?.rules?.forEach((item) => {
          const { programId, reviewType, label, expressions } = item;
          rules[programId][reviewType] = { programId, label, reviewType, expressionSets: [] }
          const expressionSetsByReviewType = []
          expressions?.forEach((expression) => {
            if (!expressionSetsByReviewType[expression.expressionSetIndex]) {
              expressionSetsByReviewType[expression.expressionSetIndex] = []
            }
            expressionSetsByReviewType[expression.expressionSetIndex].push(expression)
          })
          rules[programId][reviewType].expressionSets = expressionSetsByReviewType
        })

        state.selectedRule = rules.honors[REVIEW_TYPES.PADM.KEY]
        state.rules = rules
        state.defaults = payload.defaults
        state.rulesCopy = JSON.parse(JSON.stringify(rules))
      }
    )
    builder.addMatcher(
      graphqlApi.endpoints.saveCriteria.matchFulfilled,
      (state, { payload }) => {
        state.rulesCopy = JSON.parse(JSON.stringify(current(state.rules)))
      }
    )
  }
});

export const { addNewBlankRuleExpression, updateRuleExpression, setSelectedRule, revertRulesChanges, deleteExpression, addNewExpressionSet, deleteExpressionSet } = criteriaSlice.actions;
export const selectSelectedRule = (state) => state.criteriaSlice.selectedRule
export const selectAttributes = (state) => state.criteriaSlice.attributes
export const selectRules = (state) => state.criteriaSlice.rules
export const selectDefaults = (state) => state.criteriaSlice.defaults
export const selectRulesCopy = (state) => state.criteriaSlice.rulesCopy

export default criteriaSlice.reducer;